import { Pipe, PipeTransform } from '@angular/core';
import { DATE_FORMATS } from 'emma-common-ts';
import moment from 'moment';

/*
 * Format date
 * Usage:
 *   value | formatDate
 *   value | formatDate: formatIn formatOut
 * Example:
 *   {{ 2020/10/20 | formatDate }}
 *   formats to: 20/10/2020
 */
@Pipe({
    name: 'formatDate',
    standalone: false
})
export class FormatDatePipe implements PipeTransform {
  transform(
    value: number | string | null | undefined,
    formatIn: string = DATE_FORMATS.API,
    formatOut: string = DATE_FORMATS.DAY_MONTH_YEAR,
    ...options: any[]
  ): string {
    if (value === undefined) {
      return '';
    } else if (value === null) {
      return '-';
    }
    return moment(value, formatIn).format(formatOut);
  }
}
